import React from 'react';
import { TextField } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: theme.palette.admin.dark,
      },
    },
    '& .MuiInputLabel-outlined.Mui-focused': {
      color: theme.palette.admin.dark,
    },
  },
  textFieldRoot: {
    marginBottom: '10px',
  },
  textFieldInput: {
    color: theme.palette.admin.main,
  },
}));

const AdminTextField = ({ label, value, onChange, disabled, style, ...rest }) => {
  const classes = useStyles();
  return (
    <div className={classes.wrapper}>
      <TextField
        variant="outlined"
        label={label}
        value={value}
        onChange={onChange}
        disabled={disabled}
        style={style}
        classes={{
          root: classes.textFieldRoot,
        }}
        InputProps={{
          classes: {
            input: classes.textFieldInput,
          },
        }}
        {...rest}
      />
    </div>
  );
};

export default AdminTextField;
